<template>
    <b-col
        cols="12"
        :md="cols"
        class="pt-2"
    >
        <b-row>
            <b-col
                cols="12"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Job title`)"
                    label-for="jobTitle"
                >
                    <vue-bootstrap-typeahead v-model="contract.Label"
                                             :data="jobSuggestions" :serializer="returnText" />
                </b-form-group>
            </b-col>

            <b-col
                cols="4"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Contract type`)"
                    label-for="contactType"
                >
                    <v-select
                        :clearable="false"
                        :options="contractTypes"
                        v-model="contract.OnContractType"
                        label="text"
                        :reduce="(e) => e.value == '' ? '' : parseInt(e.value)"
                    />
                </b-form-group>
            </b-col>
            <b-col
                cols="4"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Employment type`)"
                    label-for="employmentType"
                >

                    <v-select
                        :options="employmentTypes"
                        v-model="contract.FullHalfTime"
                        label="text"
                        :clearable="false"
                        :reduce="(e) => e.value"
                    />
                </b-form-group>
            </b-col>
        </b-row>


        <b-row>
            <b-col
                cols="12"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Department`)"
                    label-for="department"
                >
                    <v-select
                        :options="departments"
                        v-model="contract.OnDepartment"
                        label="text"
                        :reduce="(e) => e.value == '' ? '' : parseInt(e.value)"
                        :clearable="false"
                    />
                </b-form-group>
            </b-col>

            <b-col
                cols="12"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Organization job level`)"
                    label-for="organizationJobLevel"
                >
                    <v-select
                        :clearable="false"
                        :options="jobLevels"
                        v-model="contract.OnOrgJobLevel"
                        label="text"
                        :reduce="(e) => e.value == '' ? '' : parseInt(e.value)"
                    />
                </b-form-group>
            </b-col>
            <b-col
                cols="4"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Subordinate to`)"
                    label-for="organizationJobLevel"
                >
                    <v-select
                        :clearable="false"
                        :options="managersList"
                        v-model="contract.OnSubordinateTo"
                        :reduce="(e) => e.value == '' ? '' : parseInt(e.value)"
                        label="text"

                    />
                </b-form-group>
            </b-col>
        </b-row>


        <b-row>
            <b-col
                cols="4"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Net Salary`)"
                    label-for="salaryNet"
                >
                    <b-form-input
                        :disabled="!iCan('financial_data', 'write')"
                        v-model="contract.OnSalaryNet" />
                </b-form-group>
            </b-col>
            <b-col
                cols="4"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Gross Salary`)"
                    label-for="salaryGross"
                >
                    <b-form-input
                        :disabled="!iCan('financial_data', 'write')"
                        v-model="contract.OnSalaryGross" />
                </b-form-group>
            </b-col>
            <b-col
                cols="4"
                md="4"
            >
                <b-form-group
                    :label="i18nT(`Salary Period`)"
                    label-for="salaryNet"
                >
                    <v-select
                        :disabled="!iCan('financial_data', 'write')"
                        :options="scheduleOptions"
                        v-model="contract.OnSalaryType"
                        label="text"
                        :reduce="e => e.value"
                        :clearable="false"
                    />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- DATE PICKERS -->
        <b-row>
            <b-col cols="4">
                <b-form-group
                    :label="i18nT(`Start date`)"
                    label-for="Start date"
                >
                    <date-picker
                        id="Start date"
                        reset-button
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :onlyDate="true"
                        :locale="locale"
                        v-model="contract.OnboardingAt"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group
                    :label="i18nT(`Evaluation period end`)"
                    label-for="evaluationPeriodEnd"
                >
                    <date-picker
                        :min="contract.OnboardingAt"
                        id="evaluationPeriodEnd"
                        reset-button
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :locale="locale"
                        v-model="contract.OnEvaluationPeriod"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group
                    :label="i18nT(`End date`)"
                    label-for="endDate"
                >
                    <date-picker
                        :min="contract.OnboardingAt"
                        id="endDate"
                        reset-button
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        :locale="locale"
                        v-model="contract.OnEnding"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </b-col>


</template>

<script>
import {BCol, BFormGroup, BFormInput, BRow} from "bootstrap-vue";
import vSelect from 'vue-select'
import DatePicker from '@core/components/DatePicker.vue'
import VueBootstrapTypeahead from "vue-typeahead-bootstrap";
import {dictToSelectArray, dictToSelectArrayWithTitle} from "@core/utils/utils";

export default {
    name: "ModalEditContractData" ,
    components: {
        BFormGroup,
        BCol,
        BFormInput,
        BRow,
        VueBootstrapTypeahead,
        DatePicker,
        vSelect
    },
    created() {
        this.$http.get(`settings/organizationLevels`).then(({ data }) => {
            this.jobLevels = data.data.map(jobLevel => ({
                value: jobLevel.Id,
                text: jobLevel.Label
            }))
        })


        this.$http.get(`tasks/assignToUsersList`).then(({data}) => {
            this.managersList = dictToSelectArray(data.data.users_list)
        })


        this.$http.get(`settings/organizationLevels`).then(({ data }) => {
            this.jobLevels = data.data.map(jobLevel => ({
                value: jobLevel.Id,
                text: jobLevel.Label
            }))
        })



        this.$http.get(`system/contractTypes`).then(({ data }) => {
            this.contractTypes = dictToSelectArray(data.data)
        })

        this.$http.get(`system/departments`).then(({ data }) => {
            this.departments = dictToSelectArray(data.data)
        })

        this.$http.get(`employees/employeesPositions`).then(({ data }) => {
            this.jobSuggestions = dictToSelectArray(data.data)
        })

    },
    data() {
        return {
            locale: this.$i18n.locale,
            jobSuggestions: [],
            jobLevels: [],
            contractTypes: [],
            managersList: [],
            departments: [],
            employmentTypes: [
                {
                    value: "1",
                    text: this.i18nT(`Full time`)
                },
                {
                    value: "2",
                    text: this.i18nT(`Part time`)
                },
            ],
            scheduleOptions: [
                {
                    value: 1,
                    text: this.i18nT(`Yearly salary`)
                },
                {
                    value: 2,
                    text: this.i18nT(`Monthly salary`)
                },
                {
                    value: 3,
                    text: this.i18nT(`Weekly salary`)
                },
                {
                    value: 4,
                    text: this.i18nT(`Daily salary`)
                },
                {
                    value: 5,
                    text: this.i18nT(`Hourly rate`)
                }
            ],
            workOptions: [
                {
                    value: 1,
                    text: this.i18nT(`Per year`)
                },
                {
                    value: 2,
                    text: this.i18nT(`Per month`)
                },
                {
                    value: 3,
                    text: this.i18nT(`Per week`)
                },
                {
                    value: 4,
                    text: this.i18nT(`Per day`)
                },
            ],
        }
    },
    props: {
        cols: {
            type: Number,
            required: false,
            default: 12
        },
        contract: {
            type: Object,
            required: false,
            default: () => ({
                Label: '',
                OnContractType: '',
                FullHalfTime: '',
                OnDepartment: '',
                OnOrgJobLevel: '',
                OnSubordinateTo: 1,
                OnSalaryNet: null,
                OnSalaryGross: null,
                OnSalaryType: '',
                OnEvaluationPeriod : '',
                OnboardingAt: '',
                OnEnding: '',
                current: false,
            })
        }
    },
    methods: {
        returnText(s) {
            return s.text
        },
    },
    watch: {
        contract: {
            handler() {
                this.$emit('updated', this.contract)
            },
            deep: true
        }
    }
}
</script>


<style scoped lang="scss">

</style>
